import {API_HOST} from 'config';
import {DistancePriceType, ICoords, IDeliveryArea, IGeoLocation, MapMdProxyResponse} from 'types/entities';

import {api} from '../setup';

const baseURL = `${API_HOST}/geo-api/map-md-proxy`;

export const geoSearchByText = (query: string): Promise<MapMdProxyResponse> => {
  return api.get(`/search`, {baseURL, params: {q: query}});
};

export const geoSearchByStreet = (streetId: string, building: string) => {
  return api.get(`/get_street`, {
    baseURL,
    params: {id: streetId, number: building},
  });
};

export const getGeoByCoords = (coords: ICoords) => {
  return api.get(`/near`, {baseURL, params: coords});
};

export const getDeliveryAreas = (): Promise<IDeliveryArea[]> => {
  return api.get(`/geo-info/delivery-areas`);
};

export const getInDeliveryArea = (coords: ICoords, query: string): Promise<{result: string}> => {
  return api.get(`/api/customer/session-data/in-delivery-area?latitude=${coords.lat}&longitude=${coords.lon}${query}`, {
    baseURL: API_HOST,
  });
};

export const fetchCourierExpressDistancePrice = (
  startLocation: IGeoLocation,
  endLocation: IGeoLocation,
  providerId: string,
): Promise<DistancePriceType> => {
  const params = {
    start_point: {
      latitude: startLocation.latitude,
      longitude: startLocation.longitude,
    },
    end_point: {
      latitude: endLocation.latitude,
      longitude: endLocation.longitude,
    },
    provider_id: providerId,
  };

  return api.post(`/restaurants/get-distance-price-courier-express`, {
    ...params,
  });
};

export const fetchCourierLocation = (courierId: number): Promise<IGeoLocation> => {
  return api.get(`/courier/${courierId}/get-location`);
};
